import kebabCase from 'lodash.kebabcase';

export function slugify(text) {
  return kebabCase(text);
}

export default slugify;
